'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormMode = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _CheckBox = require('../CheckBox');

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _Countries = require('../Countries');

var _Countries2 = _interopRequireDefault(_Countries);

var _inputTranslator = require('../inputTranslator');

var _inputTranslator2 = _interopRequireDefault(_inputTranslator);

var _smartFormReact = require('../../../../smartform/smartFormReact');

var _smartFormReact2 = _interopRequireDefault(_smartFormReact);

var _smartFormShared = require('../../../../smartform/smartFormShared');

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

var _reactRedux = require('react-redux');

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _sweetalert = require('sweetalert');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _common = require('../../../../common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common', 'Security', 'Messages');

function mapStateToProps(state) {
    return {
        phoneCountryCode: state.cart.phoneCountryCode,
        deliveryTypes: state.cart.deliveryTypes
    };
}

var ContactForm = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(ContactForm, _React$PureComponent);

    function ContactForm() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ContactForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactForm.__proto__ || (0, _getPrototypeOf2.default)(ContactForm)).call.apply(_ref, [this].concat(args))), _this), _this.smartFormInitialized = false, _this.emailInput = null, _this.badCountryCodeMsgShown = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ContactForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _smartFormReact2.default.registerSmartForms(this, 'smartform-instance-contact-form', true);
        }
    }, {
        key: 'changeState',
        value: function changeState(field, value) {
            if (field === 'phoneNumber') value = _common2.default.keepJustNumbers(value);
            this.updateAddressField(field, value);
        }
    }, {
        key: 'inputBlur',
        value: function inputBlur(field, event) {
            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
            if (!newValue) {
                return;
            }
            this.updateAddressField(field, newValue);
        }
    }, {
        key: 'updateAddressField',
        value: function updateAddressField(field, value) {
            if (this.props.onChange) {
                var updatedObject = {};
                updatedObject[field] = value;
                if (field === 'phoneNumber') {
                    updatedObject.phoneNumberWithCode = '' + this.getPhoneCountryCode() + value;
                }
                _inputTranslator2.default.addRightInput(field, updatedObject);
                this.props.onChange(updatedObject);
            }
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.props.validate();
        }
    }, {
        key: 'createInput',
        value: function createInput(field, label, isRequired, className, icon, isReadonly, maxLength, inputClass, isAutoCompleteOff, value) {
            var _this2 = this;

            var _props = this.props,
                contact = _props.contact,
                errors = _props.errors,
                readonly = _props.readonly;

            var optional = {};
            _inputTranslator2.default.addCipheredTwin(field, contact);

            if (readonly || isReadonly) {
                optional.disabled = true;
                isRequired = false;
            }

            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(field);
            var fieldNames = [field, alternativeName].filter(Boolean).map(function (name) {
                return name.toLowerCase();
            });
            var findError = function findError(errorMap) {
                return (0, _keys2.default)(errorMap).reduce(function (error, key) {
                    return error || (fieldNames.indexOf(key.split('.').pop().toLowerCase()) >= 0 ? errorMap[key] : null);
                }, null);
            };
            var error = findError(errors.clientErrors.primary || {}) || findError(errors.serverErrors.primary || {});

            return _react2.default.createElement(_FormInput2.default, (0, _extends3.default)({
                name: field,
                value: value || contact[field],
                label: label,
                isRequired: isRequired,
                className: className,
                icon: icon,
                maxLength: maxLength,
                error: error,
                onChange: function onChange(e) {
                    return _this2.changeState(field, e.target.value);
                }
            }, optional, {
                inputClassName: inputClass,
                autoComplete: isAutoCompleteOff,
                onBlur: function onBlur(e) {
                    return _this2.inputBlur(field, e);
                }
            }));
        }
    }, {
        key: 'getEmailInput',
        value: function getEmailInput(mode) {
            return this.emailInput = this.createInput('email', Resx.App.Email, true, 'col-sm-6', 'icon--mail', mode === FormMode.registered, 255, 'smartform-email smartform-instance-contact-form');
        }
    }, {
        key: 'getPhoneCountryCode',
        value: function getPhoneCountryCode() {
            var _props2 = this.props,
                selectedDeliveryId = _props2.selectedDeliveryId,
                phoneCountryCode = _props2.phoneCountryCode,
                deliveryTypes = _props2.deliveryTypes,
                contact = _props2.contact,
                isInModal = _props2.isInModal;


            if (!phoneCountryCode) {
                try {
                    phoneCountryCode = _utils2.default.getPhoneCountryCode(deliveryTypes.map(function (dt) {
                        return dt.collection[0];
                    }), selectedDeliveryId);
                } catch (e) {
                    console.error('Error in getPhoneCountryCode.', e);
                    var selectedDtElement = document.getElementById('selectedDeliveryType');
                    if (selectedDtElement) phoneCountryCode = selectedDtElement.dataset.phoneCountryCode;
                }
            }

            var countryCodePlus = !phoneCountryCode ? '' : '+' + phoneCountryCode;
            var bodyText = Resx.Messages.UnsupportedCountryCodeBody.replace('%phonenumber%', contact.phoneNumberWithCode).replace('%prefix%', countryCodePlus);

            var phoneNumWthCode = ((contact || {}).phoneNumberWithCode || '').trim();
            if (phoneNumWthCode.length > 9 && !phoneNumWthCode.startsWith(countryCodePlus) && !this.badCountryCodeMsgShown && !isInModal) {
                (0, _sweetalert2.default)({
                    text: bodyText,
                    title: Resx.Messages.UnsupportedCountryCodeTitle,
                    icon: 'warning'
                });
                this.badCountryCodeMsgShown = true;
            }
            return countryCodePlus;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                mode = _props3.mode,
                errors = _props3.errors,
                contact = _props3.contact,
                readonly = _props3.readonly,
                selectedDeliveryId = _props3.selectedDeliveryId;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                this.getEmailInput(mode),
                _react2.default.createElement(
                    'div',
                    { className: 'form__input col-2 col-sm-1 phone-country-code' },
                    _react2.default.createElement(
                        'span',
                        null,
                        this.getPhoneCountryCode()
                    )
                ),
                this.createInput('phoneNumber', Resx.App.ComplaintRequirementAcceptancePhone, true, 'col-10 col-sm-5', 'icon--phone'),
                mode === FormMode.registration && _react2.default.createElement(_FormInput2.default, { className: 'col-sm-6', name: 'password', type: 'password', label: Resx.Security.Password,
                    value: contact.password, isRequired: true,
                    error: errors.clientErrors.primary.password || errors.serverErrors.primary.password,
                    onChange: function onChange(e) {
                        return _this3.changeState('password', e.target.value);
                    } }),
                mode === FormMode.registration && _react2.default.createElement(_FormInput2.default, { className: 'col-sm-6', name: 'passwordConfirm', type: 'password',
                    label: Resx.Security.PasswordConfirm, value: contact.passwordConfirm, isRequired: true,
                    error: errors.clientErrors.primary.passwordConfirm || errors.serverErrors.primary.passwordConfirm,
                    onChange: function onChange(e) {
                        return _this3.changeState('passwordConfirm', e.target.value);
                    } }),
                this.createInput('gooseFederation', Resx.App.Name, true, 'col-sm-6', null, false, 32),
                this.createInput('hamsterPolice', Resx.App.UserLastName, true, 'col-sm-6', null, false, 32),
                this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', null, false, 100, 'smartform-address-street-and-number smartform-instance-contact-form', true),
                this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', null, false, 6, 'smartform-address-zip smartform-instance-contact-form', true),
                this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', null, false, 100, 'smartform-address-city smartform-instance-contact-form smartform-input', true),
                _react2.default.createElement(
                    'div',
                    { className: 'form__input col-sm-4' },
                    _react2.default.createElement(_Countries2.default, { selectedDeliveryId: selectedDeliveryId,
                        onChange: function onChange(e) {
                            return _this3.changeState('countryId', e.target.value);
                        },
                        value: this.props.contact.countryId, disabled: readonly }),
                    _react2.default.createElement(
                        'label',
                        null,
                        Resx.Common.Country
                    )
                ),
                mode === FormMode.registration && _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 mt-3' },
                    _react2.default.createElement(_CheckBox2.default, { name: 'subscribeToNewsletter', text: Resx.App.SubscribeToNewsletter,
                        checked: contact.subscribeToNewsletter || false,
                        onChange: function onChange(e) {
                            return _this3.changeState('subscribeToNewsletter', e.target.checked);
                        } })
                ),
                mode === FormMode.registration && _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 mt-3' },
                    _react2.default.createElement(_CheckBox2.default, { name: 'subscribeToLoyaltyProgram', text: Resx.App.SubscribeToLoyaltyProgram,
                        checked: contact.subscribeToLoyaltyProgram || false,
                        onChange: function onChange(e) {
                            return _this3.changeState('subscribeToLoyaltyProgram', e.target.checked);
                        } })
                )
            );
        }
    }]);
    return ContactForm;
}(_react2.default.PureComponent), _class2.propTypes = {
    readonly: _propTypes2.default.bool,
    contact: _propTypes2.default.object.isRequired,
    mode: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    validate: _propTypes2.default.func,
    selectedDeliveryId: _propTypes2.default.number,
    phoneCountryCode: _propTypes2.default.string,
    deliveryTypes: _propTypes2.default.array,
    isInModal: _propTypes2.default.bool,
    errors: _propTypes2.default.shape({
        clientErrors: _propTypes2.default.shape({
            primary: _propTypes2.default.shape({
                password: _propTypes2.default.string,
                passwordConfirm: _propTypes2.default.string
            })
        }),
        serverErrors: _propTypes2.default.shape({
            primary: _propTypes2.default.shape({
                password: _propTypes2.default.string,
                passwordConfirm: _propTypes2.default.string
            })
        })
    })
}, _temp2)) || _class);
var FormMode = exports.FormMode = {
    anonymous: 'anonymous',
    registered: 'registered',
    registration: 'registration',
    login: 'login'
};

exports.default = ContactForm;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/ContactForm.js
// module id = 198
// module chunks = 0 2